module.exports = __webpack_public_path__ + "static/img/juhuaR407C.4e1fb07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productList/juhua/juhuaR407C.jpg
// module id = bjZz
// module chunks = 1